import { DateTime } from 'luxon';

import { formatIsoDuration } from '@/tracker/entities/worklog';
import { TaskBasic } from '@/tracker/types';

/** «Затрачено / оценка», как на карточке доски Яндекс Трекера. null — ни логов, ни оценки */
export const formatTime = ({ spent, originalEstimation }: TaskBasic): string | null => {
  const spentText = formatIsoDuration(spent ?? 'PT0M');

  if (originalEstimation) return `${spentText} / ${formatIsoDuration(originalEstimation)}`;

  // Без оценки и без затраченного — ничего: после удаления последнего лога `spent` равен PT0M
  return spentText === '0ч' ? null : spentText;
};

/** Сколько задача в текущем статусе: «5 дн.», «3 ч» */
export const formatTimeInStatus = (since: DateTime): string => {
  const { days = 0, hours = 0 } = DateTime.now().diff(since, ['days', 'hours']).toObject();

  if (days >= 1) return `${days} дн.`;

  return hours >= 1 ? `${Math.floor(hours)} ч` : '< 1 ч';
};
